import styled from "styled-components";

export const InputBilingualStyled = styled.div`
  width: 100%;
  .lang_row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
    row-gap: 16px;
  }
  .lang_col {
    min-width: 0;
    .lang_head {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      column-gap: 8px;
      min-height: 22px;
    }
    .lang_label {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .counter {
      margin-top: 4px;
      text-align: right;
      color: ${({ theme }) => theme.COLORS.GRAY_9};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
    }
    &.is_error {
      input,
      .editor_className {
        border-color: ${({ theme }) => theme.COLORS.RED_1};
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.LAPTOP}) {
    .lang_row {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .theme_standard {
  }
`;
